<template>
  <div>
    <div class="titleDiv" v-if="enclosureTeamList.length > 0">
      <div></div>
      <p class="title">附件上传</p>
    </div>
    <div style="overflow: hidden;">
      <div v-for="(item,index) in enclosureTeamList" :key="index" style="width: 80px;float: left;text-align: center;">
        <a-upload
          name="file"
          :action="imgurl"
          listType="text"
          :showUploadList="false"
          @change="handleChangeImage($event, item)"
        >
          <div>
            <img v-if="enclosureTeam[item.name]" :src="enclosureTeam[item.name]" style="width:32px;height:32px;">
            <img v-else src="@comm/assets/img.png">
            <div class="ant-upload-text">{{ item.ismust ? '*' : '' }}{{ item.name }}</div>
            <a-icon v-if="enclosureTeam[item.name]" type="delete" @click.stop="del(item.name)"/>
          </div>
        </a-upload>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@comm/http/config'
export default {
  data () {
    return {
      enclosureTeamList: [],
      imgurl: config.baseImgURL,
      matchId: this.$route.query.matchId,
    }
  },
  props: {
    enclosureTeam: {
      type: Object,
      default: {}
    }
  },
  mounted () {
    this.findEnclosureTeam()
  },
  methods: {
    findEnclosureTeam () {
      this.combatLoading = true
      this.$api.join.findEnclosureTeam({matchId: this.$route.query.matchId}).then(res => {
        if (res.status === 0) {
          if (res.data.enclosureTeam !== null) {
            this.enclosureTeamList = JSON.parse(res.data.enclosureTeam)
          }
        }
      }).catch(err => {
        console.log('err', err)
        this.$message.error('获取失败')
      }).finally(_ => {
        this.combatLoading = false
      })
    },
    handleChangeImage (info, item) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      if (fileList[0].response) {
        this.enclosureTeam[item.name] = fileList[0].response.data.url
        item.image = fileList[0].response.data.url
        this.$emit('enclosureTeamSuccess',this.enclosureTeam)
        this.$forceUpdate()
      }
    },
    checkEnclosureTeam () {
      let bool = true
      this.enclosureTeamList.forEach(element => {
        if (element.ismust && !this.enclosureTeam[element.name]) {
          this.$message.error('请上传附件' + element.name)
          bool = false
        }
      })
      return bool
    },
    del(name){
      this.enclosureTeam[name] = ""
      this.$emit('enclosureTeamSuccess',this.enclosureTeam)
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="scss" scoped>
 .titleDiv {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    margin-top: 10px;
    div {
      height: 25px;
      width: 5px;
      background-color: #b80000;
    }
    .title {
      font-size: 19px;
      font-weight: bold;
      margin-bottom: 0px;
      margin-left: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/bigBall/EnclosureTeam.vue